import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DebugRoutingModule } from './debug-routing.module';
import { SharedModule } from '@shared/shared.module';
import { LayoutModule } from 'src/app/_layout/layout.module';
import { VoiceCheckModule } from 'src/app/_bio-check/voice-check/voice-check.module';
import { DebugConfigComponent } from './debug-config/debug-config.component';
import { DebugVoiceComponent } from './debug-voice/debug-voice.component';
import { DebugFaceComponent } from './debug-face/debug-face.component';
import { FaceCheckModule } from 'src/app/_bio-check/face-check/face-check.module';
import { DebugBrowserComponent } from './debug-browser/debug-browser.component';

@NgModule({
  declarations: [
    DebugConfigComponent,
    DebugVoiceComponent,
    DebugFaceComponent,
    DebugBrowserComponent,
  ],
  imports: [
    CommonModule,
    DebugRoutingModule,
    LayoutModule,
    SharedModule,
    FaceCheckModule,
    VoiceCheckModule,
  ],
  exports: [
    DebugBrowserComponent,
  ],
})
export class DebugModule { }
